<nz-modal
  [(nzVisible)]="isOpen"
  nzCentered
  [nzFooter]="null"
  nzCloseIcon=""
  nzZIndex="99"
  [nzMask]="false"
>
  <ng-container *nzModalContent>
    <div class="d-flex flex-column text-center align-items-center">
      <img
        src="https://storage.googleapis.com/komerce/icon/sms-red.svg"
        alt="mail"
        width="50px"
      />
      <h6 class="text-bold mt-3" style="font-size: 20px">Verify OTP Code</h6>
      <span class="text-bold">Enter Verification Code</span>
      <span>The verification code has been sent via Email to</span>
      <small class="text-muted">{{ emailTeam }}</small>
      <div
        class="mt-3 w-100 d-flex justify-content-center align-items-center gap-1"
      >
        <otp
          [setting]="settings"
          (keydown)="onKeyDown($event)"
          (onValueChange)="onChange($event)"
          [isShowButton]="false"
        ></otp>
      </div>
      <div
        *ngIf="isErrorMessage === true"
        class="p-2 my-1"
        style="background-color: #ffece9; border-radius: 8px"
      >
        <small class="text-danger">PIN yang kamu masukkan salah</small>
      </div>
      <div class="w-100 mb-3 mt-4 d-flex justify-content-center gap-3">
        <button
          [disabled]="true"
          class="btn btn-outline-secondary w-50"
          style="font-size: 12px"
        >
          Change to another method
        </button>
        <button
          [disabled]="isDisabled"
          (click)="handleConfirm()"
          [class]="
            isDisabled
              ? 'btn btn-secondary w-50'
              : 'btn btn-primary w-50 text-white'
          "
          style="font-size: 12px"
        >
          <div class="ps-3 pe-3">Confirm</div>
        </button>
      </div>
      <span
        *ngIf="seconds !== 0 || (minutes !== 0 && !isLimit)"
        class="text-center"
        >Wait <span *ngIf="minutes !== 0">{{ minutes }} minute to resend</span>
        {{ seconds }} seconds to resend</span
      >
      <span
        *ngIf="seconds === 0 && minutes === 0 && !isLimit"
        class="text-center"
        >Didn't receive the code?
        <span
          class="text-danger"
          style="cursor: pointer"
          (click)="resendVerif()"
        >
          Resend</span
        ></span
      >
      <span
        *ngIf="isLimit"
        class="text-center"
        style="color: #828282 !important"
        >Well, it looks like you're having trouble verifying your OTP, please
        contact us via live chat.</span
      >
    </div>
  </ng-container>
</nz-modal>
